import { useEffect, useState } from 'react';
import { getRewardsHistory } from '../../../auth/_requests';
import type { RewardsHistoryItem } from '../../../helpers/utils/types';

export const useWalletHistory = (token?: string) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState<RewardsHistoryItem[]>([]);

  useEffect(() => {
    const fetchHistory = async () => {
      if (!token) return;
      setLoading(true);
      try {
        const response = await getRewardsHistory(token);
        setItems(response?.data ?? []);
      } catch (error) {
        console.error('Error fetching points history:', error);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    void fetchHistory();
  }, [token]);

  return { items, loading };
};
